module.exports = __webpack_public_path__ + "media/marth.78523b36.wav";